

// Clamps a value between an upper and lower bound
const clamp = (num, min, max) => num <= min ? min : num >= max ? max : num;

// Map number x from range [a, b] to [c, d]
const map = (x, a, b, c, d) => clamp((x - a) * (d - c) / (b - a) + c, Math.min(c,d), Math.max(c,d));

// Preload images
const preloadImages = (selector = 'img') => {
    return new Promise((resolve) => {
        imagesLoaded(document.querySelectorAll(selector), resolve);
    });
};


/*
 * Debounce helper
 *
 * Remember to assign to new variable upon import. 
 * Call the function returned from the debounce function 
 * instead of calling the debounce function
 * i.e; this.debounce = debounce(this.update, 500);
 * OR; const debounceInst = debounce(() => update(), 500);
 * this.debounce();
 *
 */

const debounce = (callback, wait) => {
  let timeoutId = null;
      wait = wait || 100; // 100 by default if no param
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  };
}

const isOverflowed = (element) => {
  return element.clientWidth > element.parentElement.clientWidth;
}


const isVisible = (e) => {
    return !!( e.offsetWidth || e.offsetHeight || e.getClientRects().length );
}

const isTouchDevice = () => {
  // https://javascript.plainenglish.io/how-to-detect-a-touch-screen-device-using-javascript-68a68360375a
  return (('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0));
}


/**
 * Returns the element height including margins
 * @param element - element
 * @returns {number}
 */
const outerHeight = (element) => {
    const height = element.offsetHeight,
        style = window.getComputedStyle(element)

    return ['top', 'bottom']
        .map(side => parseInt(style[`margin-${side}`]))
        .reduce((total, side) => total + side, height)
}


export {
    map,
    clamp,
    preloadImages,
    debounce,
    isOverflowed,
    isVisible,
    isTouchDevice,
    outerHeight
};